import { useHistory } from 'react-router-dom';
import { t } from 'i18n-js';
import { PushNotification, Notification as PanelNotification } from '../../graphql/generated';
import toastr from '../../helpers/toastr';
import DefaultNotification from './notification/DefaultNotification';
import { NotificationTopic, NotificationType } from './NotificationHandlerService';
import DescriptionNotification from './notification/DescriptionNotification';

interface NotificationProps {
  notification: PanelNotification;
}

type MessageMap = Partial<Record<NotificationType, string>>;

const displayToast = (notification: PushNotification, messageMap: MessageMap): void => {
  const message = messageMap[notification.type];

  const toastFn = (msg: string): void => {
    switch (notification.type) {
      case 'SUCCESS':
        toastr.success(msg);
        break;
      case 'WARNING':
        toastr.warning(msg);
        break;
      case 'ERROR':
        toastr.error(msg);
        break;
      default:
        toastr.info(msg);
    }
  };

  if (message) {
    toastFn(message);
  }
};

export const toastNotification = (notification: PushNotification): unknown => {
  switch (notification.topic) {
    case NotificationTopic.SAVE_TIMESHEET:
      return displayToast(notification, {
        SUCCESS: t('notification.toasts.SAVE_TIMESHEET.SUCCESS'),
        ERROR: t('notification.toasts.SAVE_TIMESHEET.ERROR'),
      });
    case NotificationTopic.SUBMIT_TIMESHEET:
      return displayToast(notification, {
        SUCCESS: t('notification.toasts.SUBMIT_TIMESHEET.SUCCESS'),
        ERROR: t('notification.toasts.SUBMIT_TIMESHEET.ERROR'),
      });
    default:
      return null;
  }
};

const Notification = ({ notification }: NotificationProps): JSX.Element | null => {
  const history = useHistory();
  const { meta, metaId } = notification;
  const isTimesheetNotification = ['TIMESHEET', 'SUBMIT_TIMESHEET', 'SAVE_TIMESHEET'].includes(meta || '');
  const handleClick = () => {
    if (isTimesheetNotification && metaId) {
      return history.push(`/timesheet/${metaId}`);
    }

    if (meta === 'TIMESHEETS') {
      return history.push('/timesheets');
    }

    if (meta === 'DATA_SOURCES') {
      return history.push('/data-sources');
    }
  };

  if (isTimesheetNotification) {
    return <DescriptionNotification notification={notification} onClick={handleClick} />;
  }

  return <DefaultNotification notification={notification} onClick={handleClick} />;
};

export default Notification;
